// @flow
import * as React from 'react';
import { Link } from '../../router';
import { dirify } from '../../utils/dirify';
import styles from './styles';
import type { BreadcrumbItemType } from '../types/breadcrumb/breadcrumbItem';
import type { BreadcrumbType } from '../types/breadcrumb/breadcrumb';

type Props = {
  breadcrumb: ?BreadcrumbType,
  dealType: ?number,
};

function renderLink(link: BreadcrumbItemType, dealType: ?number): React.Node {
  switch (link.type) {
    case 'current':
      return <strong>{link.text}</strong>;
    case 'breadcrumb':
      return (
        <Link route={link.path}>
          <a>{link.text}</a>
        </Link>
      );
    case 'property_type':
      return dealType ? (
        <Link
          route={`home-deal-type-${dealType}`}
          params={{ property_type: link.route ? link.route.replace('/', '') : link.route }}
        >
          <a>{link.text}</a>
        </Link>
      ) : (
        <Link route={link.route}>
          <a>{link.text}</a>
        </Link>
      );
    default:
      return <strong>{link.text}</strong>;
  }
}

// Creates a React key
function composeListItemKey(item: BreadcrumbItemType, index: number): string {
  return item.path ? `${item.path}` : `${dirify(item.text)}-${index}`;
}

export default function Breadcrumb({ breadcrumb, dealType }: Props): React.Node {
  if (!breadcrumb || breadcrumb.length === 0) {
    return null;
  }

  return (
    <div className="breadcrumb">
      <ol itemScope itemProp="breadcrumb" itemType="http://schema.org/BreadcrumbList">
        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
          <Link route="home">
            <a itemProp="name">Trovit</a>
          </Link>
          <meta itemProp="position" content="1" />
        </li>
        {breadcrumb.map((item, index) => (
          <li
            key={composeListItemKey(item, index)}
            itemProp="itemListElement"
            itemScope
            itemType="http://schema.org/ListItem"
          >
            {renderLink(item, dealType)}
            <meta itemProp="position" content={index + 1} />
          </li>
        ))}
      </ol>
      <span className="gradient" />
      <style jsx>{styles}</style>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/common/Breadcrumb/index.js